import { z } from "zod";

export const DefaultParticipantSchema = z.object({
	firstName: z.string().min(1, "First name is required"),
	lastName: z.string().min(1, "Last name is required"),
	internalRoles: z.string().min(1, "Internal role is required"),
	scenarioRoles: z.string().min(1, "Scenario roles are required"),
});

export type DefaultParticipantFormType = z.infer<typeof DefaultParticipantSchema>;
